import { MemoJS } from "@memojs/library";

console.log(MemoJS);

window.addEventListener("load", setup);

function setup() {
    const memo = new MemoJS('md/index.md');
    console.log(memo);

    //custom css
    setTimeout( () => {

        const img = document.getElementsByTagName("img");

        for(var i=0; i < img.length; i++){

            const parent = img[i].parentElement;
            if(parent !== undefined && parent.tagName === "P"){
                parent.style.textAlign = "center";
            }
        }
    }, 100);
};